module.exports = __webpack_public_path__ + "static/media/catacaise.d98f5ccd.png";